var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
export const API = {
    get: function ({ url, params, config }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.get(url, Object.assign({ params }, config));
            return response.data;
        });
    },
    post: function ({ url, config, data }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.post(url, data, config);
            return response.data;
        });
    },
};
export const parseUrl = (url) => {
    const fixed = url.replace("https://", "").replace("http://", "");
    if (fixed[fixed.length - 1] === "/") {
        return fixed.slice(0, fixed.length - 1);
    }
    return fixed;
};
//# sourceMappingURL=API.js.map